import CrudOperationsMixin from './CrudOperationsMixin.js'
import Constants from './Constants.js'

export default {
  mixins: [
    CrudOperationsMixin
  ],
  data() {
    return {
      triggers: Constants.triggers.filter(x => x.value),
    };
  },
  methods: {
    getTriggerText: function (trigger) {
      return this.triggers.find(x => x.value == trigger).text;
    },
    moveUp: function (subscriptionId) {
      return new Promise((resolve, reject) => {
        this.query('/graphql/public', {
          query: `
            mutation ($subscriptionId: ID!) {
              moveUp(subscriptionId: $subscriptionId) {
                id
              }
            }`,
          variables: {
            'subscriptionId': subscriptionId
          }}, (data) => {
            resolve(data.moveUp);
          }, () => {
            reject();
          });
      });
    },
    moveDown: function (subscriptionId) {
      return new Promise((resolve, reject) => {
        this.query('/graphql/public', {
          query: `
            mutation ($subscriptionId: ID!) {
              moveDown(subscriptionId: $subscriptionId) {
                id
              }
            }`,
          variables: {
            'subscriptionId': subscriptionId
          }}, (data) => {
            resolve(data.moveDown);
          }, () => {
            reject();
          });
      });
    },
    removeSubscription: function (subscription, station) {
      return new Promise((resolve, reject) => {
        this.query('/graphql/public', {
          query: `
            mutation ($subscriptionId: ID!) {
              unsubscribe(subscriptionId: $subscriptionId) {
                id
              }
            }`,
          variables: {
            'subscriptionId': subscription.id
          }}, (data) => {
            resolve(data.unsubscribe);
          }, () => {
            reject();
          }, 'Station Removed', 'Unable to Remove Station', station.displayCity + ' was removed from My NAB.');
      });
    },
    updateSubscription: function (subscriptionId, trigger) {
      return new Promise((resolve, reject) => {
        this.query('/graphql/public', {
          query: `
            mutation ($subscriptionId: ID!, $trigger: SubscriptionTrigger!) {
              changeTrigger(subscriptionId: $subscriptionId, trigger: $trigger) {
                id,
                trigger,
                displayWeight,
                station {
                  id
                  name
                  displayCity
                  state
                  postalCode
                  country
                  scaleSet {
                    id,
                    scales {
                      id,
                      category,
                      range1Begin,
                      range2Begin,
                      range3Begin,
                      range4Begin
                    }
                  }
                }
              }
            }`,
          variables: {
            'subscriptionId': subscriptionId,
            'trigger': trigger
          }}, (data) => {
            this.$parent.showToast('Your email alerts for ' + data.changeTrigger.station.displayCity + ' were updated.', {
              title: 'Email Alerts Changed',
              variant: 'success',
              autoHideDelay: 5000
            });

            resolve(data.changeTrigger);
          }, () => {
            reject();
          }, null, 'Unable to Change Email Alerts');
        });
    },
    addSubscription: function (stationId, trigger) {
      return new Promise((resolve, reject) => {
        this.query('/graphql/public', {
          query: `
            mutation ($stationId: ID!, $trigger: SubscriptionTrigger!) {
              subscribe(stationId: $stationId, trigger: $trigger) {
                id,
                trigger,
                displayWeight,
                station {
                  id
                  name
                  displayCity
                  state
                  postalCode
                  country
                  scaleSet {
                    id,
                    scales {
                      id,
                      category,
                      range1Begin,
                      range2Begin,
                      range3Begin,
                      range4Begin
                    }
                  }
                }
              }
            }`,
          variables: {
            'stationId': stationId,
            'trigger': trigger
          }}, (data) => {
            this.$parent.showToast(data.subscribe.station.displayCity + ' was added to My NAB.', {
              title: 'Station Added to My NAB',
              variant: 'success',
              autoHideDelay: 5000
            });

            resolve(data.subscribe);
          }, () => {
            reject();
          }, null, 'Unable to Add Station');
        });  
    }
  }
}
